import React from "react";
import { Button, Divider, Grid, MenuItem, Typography } from "@mui/material";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import CustomSelect from "src/components/forms/theme-elements/CustomSelect";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
// import { useDispatch } from "react-redux";
// import { toast } from "react-toastify";
import SubscriptionService from "src/service/subscription";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";
const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: " Add Plan and Subscription ",
  },
];

const validationSchema = yup.object({
  plan_name: yup
    .string("paln Name")
    .min(2, "paln Name should be of minimum 2 characters in length")
    .max(30, "paln Name should be of maximum 30 characters in length")
    .required("paln Name is required"),

  plan_type: yup.string("plan type").required("paln type is required"),

  validity: yup
    .string("plan validity")
    .matches(/^[0-9]+$/, "plan validity should only contain digits")
    .min(2, "paln validity should be of minimum 2 characters in length")
    .max(30, "paln validity should be of minimum 30 characters in length")
    .required("paln validity is required"),

  charge: yup
    .string("plan charge")
    .matches(/^[0-9.]+$/, "plan charge should only contain digits")
    .min(2, "paln charge should be of minimum 2 characters in length")
    .max(30, "paln charge should be of minimum 30 characters in length")
    .required("paln charge is required"),
});

const plan = [
  {
    value: "1",
    label: "One Time",
  },
  {
    value: "2",
    label: "Yearly",
  },
];

const AddPlanSubscription = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const initialValues = {
    manufacturer_id: sessionData.data.id,
    plan_name: "",
    plan_type: "",
    validity: "",
    charge: "",
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        // alert(JSON.stringify(values, null, 2));
        try {
          const res = await SubscriptionService.addSubscription(values);

          swal("success", res.message, "success");
          setTimeout(() => {
            navigate("/planAndSubscription");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  return (
    <div>
      <Breadcrumb title="Add Plan and Subscription" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Add Plan and Subscription
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/planAndSubscription");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {/*   ==== manufacturer name  -===  */}
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "10px" }}
            >
              <CustomFormLabel htmlFor="plan_name">
                Plan Name <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="plan_name"
                name="plan_name"
                type="text"
                value={values.plan_name}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.plan_name && Boolean(errors.plan_name)}
                helperText={touched.plan_name && errors.plan_name}
                variant="outlined"
                placeholder="Enter plan name"
                fullWidth
              />
            </Grid>

            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "10px" }}
            >
              <CustomFormLabel htmlFor="fs-language">
                Plan Type <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomSelect
                id="plan_type"
                name="plan_type"
                value={values.plan_type}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.plan_type && Boolean(errors.plan_type)}
                helperText={touched.plan_type && errors.plan_type}
                fullWidth
                variant="outlined"
              >
                <MenuItem value=""> select </MenuItem>
                {plan.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </CustomSelect>
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="validity">
                Plan Validity (Days) <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="validity"
                name="validity"
                type="text"
                value={values.validity}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.validity && Boolean(errors.validity)}
                helperText={touched.validity && errors.validity}
                variant="outlined"
                placeholder="Enter Plan validity"
                fullWidth
              />
            </Grid>
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={12}
              style={{ marginTop: "-10px" }}
            >
              <CustomFormLabel htmlFor="charge">
                Plan Charge (₹) <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <CustomTextField
                id="charge"
                name="charge"
                type="text"
                value={values.charge}
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.charge && Boolean(errors.charge)}
                helperText={touched.charge && errors.charge}
                variant="outlined"
                placeholder="Enter Plan charge"
                fullWidth
              />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Button color="success" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default AddPlanSubscription;
